const SELECTED_CROP_SEASONS_STORAGE_KEY = 'selectedCropSeasons';

export const getSelectedCropSeasonIds = (): string[] => {
  try {
    const rawSelectedCropSeasonIds = localStorage.getItem(
      SELECTED_CROP_SEASONS_STORAGE_KEY
    );
    if (!rawSelectedCropSeasonIds) {
      return [];
    }

    const parsedSelectedCropSeasonIds = JSON.parse(rawSelectedCropSeasonIds);
    if (!Array.isArray(parsedSelectedCropSeasonIds)) {
      return [];
    }

    return parsedSelectedCropSeasonIds.filter(
      (id): id is string => typeof id === 'string'
    );
  } catch {
    return [];
  }
};

interface CropSeasonMismatchCriteria {
  sourceGroupCount: number;
  sourceCropSeasonIds?: string[];
  selectedCropSeasonIds?: string[];
}

export const hasCropSeasonMismatch = ({
  sourceGroupCount,
  sourceCropSeasonIds = [],
  selectedCropSeasonIds = []
}: CropSeasonMismatchCriteria): boolean => {
  return (
    sourceGroupCount > 1 &&
    sourceCropSeasonIds.some(id => !selectedCropSeasonIds.includes(id))
  );
};

interface OperationLikeSource {
  properties?: unknown[];
  cropSeasonIds?: string[];
}

export const shouldShowOperationCropSeasonMismatch = (
  operation?: OperationLikeSource,
  selectedCropSeasonIds: string[] = []
) => {
  if (!operation) {
    return false;
  }

  return hasCropSeasonMismatch({
    sourceGroupCount: operation.properties?.length ?? 0,
    sourceCropSeasonIds: operation.cropSeasonIds ?? [],
    selectedCropSeasonIds
  });
};

interface RecommendationLikeSource {
  cropZones?: unknown[];
  cropSeasonIds?: string[];
}

export const shouldShowRecommendationCropSeasonMismatch = (
  recommendation?: RecommendationLikeSource,
  selectedCropSeasonIds: string[] = []
) => {
  if (!recommendation) {
    return false;
  }

  return hasCropSeasonMismatch({
    sourceGroupCount: recommendation.cropZones?.length ?? 0,
    sourceCropSeasonIds: recommendation.cropSeasonIds ?? [],
    selectedCropSeasonIds
  });
};
